export const concatenateItemNames = items => {
  const itemNames = [];

  items.forEach(item => {
    itemNames.push(item.name);
  });

  return itemNames.join(', ');
};
